import gql from 'graphql-tag';

export const CampaignFields = gql`
  fragment CampaignFields on Campaign {
    id
    name
    type
    status
    startDate
    endDate
    budgetTotal
    budgetByDay
    cpm
    contractCPM
    advertiserPercentage
    contractPercentage
    demandSidePlatform
    adProviderId
    maxBid
    isLaunchProgrammatically
    hasMediaPlanStrategy
    valueAdd
    flightSchedules {
      id
      startDate
      endDate
      budget
      cpm
      createdAt
      updatedAt
    }
    orgs {
      id
      CPAcronym
    }
    # Line Items
    lineItems {
      id
      name
      startDate
      endDate
      cpm
      targetingType
      budgetTotal
      valueAdd
      isOrigin
      markedForDelivery
      maxBid
      frequencyCap
      supplySidePlatform
      dspLineItemId
      status
      dealIds {
        id
        dealId
        name
        org {
          id
        }
      }
      dspDealIds {
        id
        dspInternalId
        dealId
        name
        cpmBid
      }
      beacons {
        id
        beaconId
        name
        advertiserId
        beaconType
      }
      targetingRegions {
        id
        name
        isActive
        isPresetList
        regions
        createdAt
      }
      targetingLocations {
        id
        name
        type
        isAmplifyDefault
        geoTargets {
          ...CampaignGeoTargetFields
        }
        eventsTargets {
          id
        }
        createdAt
        createdBy {
          id
          name
        }
        orgs {
          id
          name
          CPAcronym
        }
      }
      targetingCountries {
        id
        code
        name
      }
      audienceType
      firstPartyDataAudiences {
        id
        name
        activated
        deviceCount
        matchRate
        isProcessedByStatera
        createdAt
        dspSegmentIds
        hashedEmails {
          id
        }
        # hashedEmailsCount
      }
      adGroup {
        id
        clickthrough
        adGroupCreatives {
          id
          name
          clickthrough
          startDate
          endDate
          createdAt
          updatedAt
          medias {
            id
            name
            size
            fileType
            height
            width
            length
            key
            url
            type
            mediaNotes
            status
            dspCreativeId
            dspAdId
          }
          isAmplifyDefault
        }
      }
      flightSchedules {
        id
        startDate
        endDate
        budget
        cpm
        createdAt
        updatedAt
      }
      segments {
        id
        segmentId
        name
        segmentType
        cost
      }
      inventorySources {
        id
        sourceId
        name
      }
      inventoryLists {
        id
        listId
        name
        action
        inventoryUsage
      }
    }
  }
`;

export const CampaignGeoTargetFields = gql`
  fragment CampaignGeoTargetFields on GeoTarget {
    vwiUpdated
    id
    name
    start
    end
    status
    orgs {
      id
      name
    }
    circles {
      id
      radius
      location {
        id
        name
        formattedAddress
        zip
        street
        city
        county
        state
        country
        lat
        lng
      }
      coordinate {
        id
        lat
        lng
      }
    }
    polygons {
      id
      geometry
      location {
        id
        name
        formattedAddress
        zip
        street
        city
        county
        state
        country
        lat
        lng
      }
    }
    location {
      id
      name
      formattedAddress
      zip
      street
      city
      county
      state
      country
      lat
      lng
    }
  }
`;

export const CampaignRequestorFields = gql`
  ${CampaignGeoTargetFields}
  ${CampaignFields}

  fragment CampaignRequestorFields on CampaignOrder {
    # Details
    id
    name
    description
    type
    cpm
    pricingModel
    freeImpressions
    aggregateData {
      id
      overallData {
        id
        aggImpressions
      }
    }
    advertiser {
      id
      name
      cpm
      CPAcronym
      salesforceId
      billingEmail
      parentOrg {
        id
        name
        billingEmail
        salesforceId
        pricingModel {
          id
          hasContract
        }
      }
      externalCRMCampaignIntegrations {
        id
        metadata
      }
      dataConfig {
        dspAdvertiserId
      }
      pricingModel {
        id
        hasContract
        model
        cpmList {
          id
          type
          advertiserCPM
          contractCPM
        }
        auctionPlus {
          id
          advertiserPercentage
          contractPercentage
        }
      }
    }
    status

    # Duration & Budget
    startDate
    endDate
    budget

    # Categories
    isRegulated
    advertiserType
    measureWalkInTraffic
    category
    attributionTargets {
      ...CampaignGeoTargetFields
    }

    # Attribution Reporting
    awarenessCampaign
    transactionTarget
    transactionsConfig {
      id
      appId
      cart
      cartProvider
      traffId
      tracksBasketItems
      gtmAccess
      gtmStatus
      tag
    }
    signUpCampaign
    signUpConfig {
      id
      appId
      locationId
      name
    }
    pageViewConfig {
      id
      appId
      locationId
    }
    sessionConfig {
      id
      appId
      cart
    }
    geoTargets {
      ...CampaignGeoTargetFields
    }
    targetingCriteria

    # Line Items
    campaigns {
      ...CampaignFields
    }

    reviewerId
    notes
    reviewNotes
    histories {
      id
      action
      author {
        id
        name
      }
      property
      campaignOrder {
        id
        name
      }
      data
      createdAt
      updatedAt
    }
    dspConfig
    version
    requesterVersion
    renewalStatus
    IONumber
    salesforceId
    additionalIONumbers {
      id
      value
      createdAt
    }
    externalCRMIntegrations {
      id
      externalCRMId
      metadata
    }
    attachments {
      id
      referenceId
    }
    productCode
    complianceAudiences {
      id
      name
      type
      geoTargets {
        id
        name
        location {
          id
          name
        }
      }
    }
  }
`;
